export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SiteButton.vue?vue&type=template&id=13c8a20a&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/SiteButton.vue?vue&type=template&id=13c8a20a&scoped=true&
// module id = 147
// module chunks = 0